import Hero from './components/Hero';
import Features from './components/Features';
import Architecture from './components/Architecture';
import Scenarios from './components/Scenarios';
import Dashboard from './components/Dashboard';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <Features />
      <Architecture />
      <Scenarios />
      <Dashboard />
      <Testimonial />
      <Footer />
    </div>
  );
}